import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { stocksAction } from "src/store/Slices/Administrator/StocksSlice";
// import AddEditStocksModal from './Modals/AddEditStocksModal'
// import MobileStocks from './Mobile/MobileStocks'
import { trainingRecordsAction } from "src/store/Slices/Administrator/TrainingRecordsSlice";
import {
  formatIsoToDateNew,
  formatIsoToTime,
  formateDate,
} from "src/components/helpers/formateDate";
import { openNotification } from "src/components/helpers/notification";
import { element } from "prop-types";
import Title from "antd/es/skeleton/Title";
import { width } from "@mui/system";
import MobileTrainingRecords from "./Mobile/MobileTrainingRecords";
import dayjs from "dayjs";

const TrainingRecords = ({ mnemo }) => {
  const dispatch = useDispatch();

  const filterOptionsArr = [
    {label: 'Фильрация', value: 0, index: undefined},
    {label: 'По номеру', value: 1, index: 'id', title: 'Расписание'},
    {label: 'По ФИО', value: 2,  index: 'userFio', title: 'ФИО'},
    {label: 'По телефону', value: 3, index: 'userPhone', title: 'Телефон'},
    {label: 'По наименованию', value: 4, index: 'name', title: 'Наименование'},
    {label: 'По тренеру', value: 5, index: 'employName', title: 'Тренер'},
    {label: 'По залу', value: 6, index: 'className', title: 'Зал'},
    {label: 'По клубу', value: 7, index: 'clubName', title: 'Клуб'},
    {label: 'По услуге', value: 8, index: 'serviceName', title: 'Услуга'},
    {label: 'По дате', value: 9, index: 'date', title: 'Дата'},
    {label: 'По времени', value: 10, index: 'time', title: 'Время'},
  ]

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
    open: false,
    flag: "",
  });
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  // STORE
  const trainingRecordsList = useSelector(
    (state) => state.TrainingRecordsSlice.trainingRecordsList
  );
  const trainingRecordsLoading = useSelector(
    (state) => state.TrainingRecordsSlice.trainingRecordsLoading
  );
  const rows = trainingRecordsList?.data?.value?.rows.map((element) => {
    return {
      key: element?.key,
      name: element?.name,
      date: element.date,
      time: element?.time,
      className: element.className,
      clubName: element.clubName,
      employName: element.employName,
      id: element.id,
      serviceName: element.serviceName,
      userFio: element.userFio,
      userPhone: element.userPhone,
    };
  });

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const newDate = new Date();

  trainingRecordsList?.data?.value?.totalCount === 0 &&
    openNotification({
      type: "info",
      message:
        'За выбранный период (по умолчанию сегодня) нет записей, попробуйте изменить фильтр "Дата"',
    });

  const dateFrom = `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${
    months[newDate.getMonth()]
  } ${newDate.getFullYear()} 00:00:00`;
  const dateTo = `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${
    months[newDate.getMonth()]
  } ${newDate.getFullYear()} 23:59:59`;
  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["IdFrom"] = values[index][0];
            formattedItems["IdTo"] = values[index][1];
          } else if (key === "date") {
            formattedItems["DateFrom"] = values[index][0];
            formattedItems["DateTo"] = values[index][1];
          } else if (key === "serviceName") {
            formattedItems["ServiceId"] = values[index][0];
          } else if (key === "className") {
            formattedItems["ClassId"] = values[index][0];
          } else if (key === "time") {
            formattedItems["TimeFrom"] = dayjs(values[index][0]).format(
              "HH:mm:ss"
            );
            formattedItems["TimeTo"] = dayjs(values[index][1]).format(
              "HH:mm:ss"
            );
          } else if (key === "clubName") {
            formattedItems["clubId"] = values[index][0];
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      trainingRecordsAction({
        flag: "get",
        value: {
          DateFrom: dateFrom,
          DateTo: dateTo,
          Count: pagination.pageSize,
          Offset: pagination.pageSize * (pagination.current - 1),
          OrderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const clickOnAction = (element) => {
      //(element)
    }
  
    const handlePaginationChange = (page, pageSize) => {
      dispatch(trainingRecordsAction({
      flag: 'get', value: {
          count: pageSize,
          offset: pageSize * (page - 1),
          }
      }))
      setPage(page)
      setPageSize(pageSize)
    }

  useEffect(() => {
    dispatch(
      trainingRecordsAction({
        flag: "get",
        value: {
          DateFrom: dateFrom,
          DateTo: dateTo,
        },
      })
    );
  }, []);

  return (
    <>
      {/* <AddEditStocksModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                stockInfo={stockInfo}
            /> */}
      {/* <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            /> */}
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={trainingRecordsLoading}
          columns={trainingRecordsList}
          rows={rows}
          total={trainingRecordsList?.data?.value?.totalCount}
        />
      ) : (
        <>
          <MobileTrainingRecords //изменить на общую мобилку
            page={page}
            setPage={setPage}
            setPageSize={setPageSize}
            servicesList={trainingRecordsList}
            servicesListLoading={trainingRecordsLoading}
          />
        </>
      )}
    </>
  );
};

export default TrainingRecords;
